document.addEventListener("DOMContentLoaded", () => {



  
//-----------------------------------------------------------------
// This function is for the HOVER ANIMATION 
//-----------------------------------------


//   function hoverText() {
//   // Exit early if GSAP is not loaded
//   if (typeof gsap === "undefined") {
//     console.warn("GSAP library is not loaded. Hover text animations will not work.");
//     return;
//   }

//   // Select all staggered items
//   const items = document.querySelectorAll(".staggered-item");

//   // Exit early if no items are found
//   if (!items.length) {
//     console.warn("No staggered items (.staggered-item) found on the page.");
//     return;
//   }

//   items.forEach((item) => {
//     // Find the main span
//     const mainSpan = item.querySelector("span");

//     // Skip item if main span is not found
//     if (!mainSpan) {
//       console.warn("Main span not found in staggered item:", item);
//       return;
//     }

//     const originalText = mainSpan.innerText;
//     mainSpan.innerHTML = "";

//     // Create default and hover layers
//     const defaultLayer = document.createElement("div");
//     defaultLayer.classList.add("default-text");

//     const hoverLayer = document.createElement("div");
//     hoverLayer.classList.add("hover-text");

//     // Split text into characters
//     originalText.split("").forEach((char) => {
//       const defaultChar = document.createElement("span");
//       defaultChar.classList.add("letter");
//       defaultChar.textContent = char === " " ? "\u00A0" : char;
//       defaultLayer.appendChild(defaultChar);

//       const hoverChar = document.createElement("span");
//       hoverChar.classList.add("letter");
//       hoverChar.textContent = char === " " ? "\u00A0" : char;
//       hoverLayer.appendChild(hoverChar);
//     });

//     // Append layers to main span
//     mainSpan.appendChild(defaultLayer);
//     mainSpan.appendChild(hoverLayer);

//     // Select letters
//     const defaultLetters = defaultLayer.querySelectorAll(".letter");
//     const hoverLetters = hoverLayer.querySelectorAll(".letter");

//     // Verify letters exist
//     if (!defaultLetters.length || !hoverLetters.length) {
//       console.warn("No letters found in default or hover layers for item:", item);
//       return;
//     }

//     // Create GSAP timeline
//     const tl = gsap.timeline({ paused: true });

//     defaultLetters.forEach((letter, i) => {
//       // Ensure hoverLetters[i] exists
//       if (hoverLetters[i]) {
//         tl.to(letter, { y: "-100%", duration: 0.50, ease: "expo.inOut" }, i * 0.01)
//           .to(hoverLetters[i], { y: "0%", duration: 0.50, ease: "expo.inOut" }, i * 0.01);
//       }
//     });

//     // Add event listeners
//     item.addEventListener("mouseenter", () => tl.play());
//     item.addEventListener("mouseleave", () => tl.reverse());
//   });
// }

// // Run the function
// hoverText();



function hoverText() {
  // Exit early if GSAP is not loaded
  if (typeof gsap === "undefined") {
    console.warn("GSAP library is not loaded. Hover text animations will not work.");
    return;
  }

  // Select all staggered items
  const items = document.querySelectorAll(".staggered-item");

  // Exit early if no items are found
  if (!items.length) {
    console.warn("No staggered items (.staggered-item) found on the page.");
    return;
  }

  items.forEach((item) => {
    // Find the main span
    const mainSpan = item.querySelector("span");

    // Skip item if main span is not found
    if (!mainSpan) {
      console.warn("Main span not found in staggered item:", item);
      return;
    }

    // Create default and hover layers
    const defaultLayer = document.createElement("div");
    defaultLayer.classList.add("default-text");

    const hoverLayer = document.createElement("div");
    hoverLayer.classList.add("hover-text");

    // Process child nodes of mainSpan
    const nodes = Array.from(mainSpan.childNodes);
    mainSpan.innerHTML = ""; // Clear the main span

    nodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // Handle text nodes by splitting into characters
        const text = node.textContent || "";
        text.split("").forEach((char) => {
          const defaultChar = document.createElement("span");
          defaultChar.classList.add("letter");
          defaultChar.textContent = char === " " ? "\u00A0" : char;
          defaultLayer.appendChild(defaultChar);

          const hoverChar = document.createElement("span");
          hoverChar.classList.add("letter");
          hoverChar.textContent = char === " " ? "\u00A0" : char;
          hoverLayer.appendChild(hoverChar);
        });
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Handle elements (e.g., <span>) by cloning them
        const defaultElement = node.cloneNode(true);
        defaultElement.classList.add("letter");
        defaultLayer.appendChild(defaultElement);

        const hoverElement = node.cloneNode(true);
        hoverElement.classList.add("letter");
        hoverLayer.appendChild(hoverElement);
      }
    });

    // Append layers to main span
    mainSpan.appendChild(defaultLayer);
    mainSpan.appendChild(hoverLayer);

    // Select letters (including both characters and elements)
    const defaultLetters = defaultLayer.querySelectorAll(".letter");
    const hoverLetters = hoverLayer.querySelectorAll(".letter");

    // Verify letters exist
    if (!defaultLetters.length || !hoverLetters.length) {
      console.warn("No letters found in default or hover layers for item:", item);
      return;
    }

    // Create GSAP timeline
    const tl = gsap.timeline({ paused: true });

    defaultLetters.forEach((letter, i) => {
      // Ensure hoverLetters[i] exists
      if (hoverLetters[i]) {
        tl.to(letter, { y: "-100%", duration: 0.50, ease: "expo.inOut" }, i * 0.01)
          .to(hoverLetters[i], { y: "0%", duration: 0.50, ease: "expo.inOut" }, i * 0.01);
      }
    });

    // Add event listeners
    item.addEventListener("mouseenter", () => tl.play());
    item.addEventListener("mouseleave", () => tl.reverse());
  });
}

// Run the function
hoverText();

  
//-----------------------------------------------------------------
// This function is for the TABING in PDP 
//-----------------------------------------


function tabingSystem() {
  // Select the top-level section
  const topLevelSection = document.querySelector(".tab_slides--section");

  // Exit early if the top-level section is not found
  if (!topLevelSection) {
    console.warn("Top-level tab section (.tab_slides--section) not found.");
    return;
  }

  // Select menu items and content sections
  const topLevelMenuItems = topLevelSection.querySelectorAll(".tab_nav .tab_item");
  const topLevelContentSections = topLevelSection.querySelectorAll(".tab_slides--inner > .tab_slides-container");

  // Exit early if no menu items or content sections are found
  if (!topLevelMenuItems.length) {
    console.warn("No top-level menu items (.tab_nav .tab_item) found.");
    return;
  }
  if (!topLevelContentSections.length) {
    console.warn("No top-level content sections (.tab_slides--inner > .tab_slides-container) found.");
    return;
  }

  const showTopLevelContent = (targetId) => {
    topLevelContentSections.forEach((section) => section.classList.remove("active"));
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add("active");
      if (targetId === "features") {
        subTabSystem();
      }
    } else {
      console.error(`Top-level tab content with ID ${targetId} not found.`);
    }
  };

  topLevelMenuItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      topLevelMenuItems.forEach((menuItem) => menuItem.parentElement?.classList.remove("active"));
      if (item.parentElement) {
        item.parentElement.classList.add("active");
      } else {
        console.warn("Parent element for menu item not found:", item);
      }
      const targetId = item.getAttribute("data-target");
      if (targetId) {
        showTopLevelContent(targetId);
      } else {
        console.warn("No data-target attribute found on menu item:", item);
      }
    });
  });

  // Initialize the first top-level tab
  if (topLevelMenuItems.length > 0) {
    const firstTargetId = topLevelMenuItems[0].getAttribute("data-target");
    if (firstTargetId) {
      showTopLevelContent(firstTargetId);
      if (topLevelMenuItems[0].parentElement) {
        topLevelMenuItems[0].parentElement.classList.add("active");
      } else {
        console.warn("Parent element for first menu item not found.");
      }
    } else {
      console.warn("No data-target attribute found on first menu item.");
    }
  }
}

function subTabSystem() {
  // Select the features section
  const featuresSection = document.getElementById("features");

  // Exit early if features section is not found
  if (!featuresSection) {
    console.warn("Features section (#features) not found.");
    return;
  }

  // Select sub-tab menu items and content sections
  const subTabMenuItems = featuresSection.querySelectorAll(".sub_tab-nav .sub_tab_item");
  const subTabContentSections = featuresSection.querySelectorAll("#sub-Tabs .sub-tab");

  // Exit early if no sub-tab menu items or content sections are found
  if (!subTabMenuItems.length) {
    console.warn("No sub-tab menu items (.sub_tab-nav .sub_tab_item) found.");
    return;
  }
  if (!subTabContentSections.length) {
    console.warn("No sub-tab content sections (#sub-Tabs .sub-tab) found.");
    return;
  }

  const showSubTabContent = (targetId) => {
    subTabContentSections.forEach((section) => section.classList.remove("active"));
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add("active");
    } else {
      console.error(`Sub-tab content with ID ${targetId} not found.`);
    }
  };

  subTabMenuItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      subTabMenuItems.forEach((menuItem) => menuItem.parentElement?.classList.remove("active"));
      if (item.parentElement) {
        item.parentElement.classList.add("active");
      } else {
        console.warn("Parent element for sub-tab menu item not found:", item);
      }
      const targetId = item.getAttribute("data-target");
      if (targetId) {
        showSubTabContent(targetId);
      } else {
        console.warn("No data-target attribute found on sub-tab menu item:", item);
      }
    });
  });

  // Initialize the first sub-tab
  if (subTabMenuItems.length > 0) {
    const firstTargetId = subTabMenuItems[0].getAttribute("data-target");
    if (firstTargetId) {
      showSubTabContent(firstTargetId);
      if (subTabMenuItems[0].parentElement) {
        subTabMenuItems[0].parentElement.classList.add("active");
      } else {
        console.warn("Parent element for first sub-tab menu item not found.");
      }
    } else {
      console.warn("No data-target attribute found on first sub-tab menu item.");
    }
  }
}

// Run the tabbing system
tabingSystem();

  
  

//-----------------------------------------------------------------
// This function is for the ACCORDION in PDP tabing with animation
//-----------------------------------------

  
function accordionItems() {
  // Select all buttons with the class .accordion_item-tips
  const buttons = document.querySelectorAll(".accordion_item-tips");

  // Exit early if no buttons are found
  if (!buttons.length) {
    console.warn("No accordion buttons found on the page.");
    return;
  }

  // Add click event listeners to all buttons
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      // Find the content element (next sibling of the button's parent)
      const content = button.parentElement?.nextElementSibling;

      // Check if content exists
      if (!content) {
        console.error("Accordion content not found for button:", button);
        return;
      }

      // Toggle the is_open class
      const isOpen = content.classList.toggle("is_open");
      button.classList.toggle("is_open", isOpen);

      if (isOpen) {
        // Use setTimeout to ensure content is rendered before setting height
        setTimeout(() => {
          content.style.height = `${content.scrollHeight}px`;
        }, 0);

        // Animate list items if they exist
        const items = content.querySelectorAll(".accordion_content-items li");
        if (items.length) {
          gsap.set(items, { opacity: 0, y: -20 });
          gsap.to(items, {
            opacity: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.1,
            ease: "power2.out",
          });
        }
      } else {
        content.style.height = "0";
      }
    });
  });
}

// Check if GSAP is loaded before running the function
if (typeof gsap !== "undefined") {
  accordionItems();
} else {
  console.warn("GSAP library is not loaded. Accordion functionality may not work as expected.");
}

  
  /*----------------------------
    VIDEO PREVIEW LOGIC  
  ----------------*/

  // function handleVideoPreview() {
  //   const videoPreviews = document.querySelectorAll(".video-preview");
  //   const startTime = 0;
  //   const endTime = 5;

  //   videoPreviews.forEach((preview, index) => {
  //     // Select all required elements
  //     const previewVideo = preview.querySelector(".preview-video");
  //     const playButton = preview.querySelector(".play-button");
  //     const videoPopup = document.getElementById(`dialog-video__${index + 1}`);
  //     const popupContent = document.getElementById(
  //       `dialog-content__${index + 1}`
  //     );
  //     const fullVideo = document.getElementById(
  //       `dialog-full__video-${index + 1}`
  //     );
  //     const closeButton = document.getElementById(
  //       `dialog-close__btn-${index + 1}`
  //     );
  //     const loader = document.getElementById(`loader-${index + 1}`);

  //     // Validate all required elements exist
  //     if (
  //       !previewVideo ||
  //       !playButton ||
  //       !videoPopup ||
  //       !popupContent ||
  //       !fullVideo ||
  //       !closeButton ||
  //       !loader
  //     ) {
  //       console.error(`Missing elements for video block ${index + 1}`, {
  //         previewVideo: !!previewVideo,
  //         playButton: !!playButton,
  //         videoPopup: !!videoPopup,
  //         popupContent: !!popupContent,
  //         fullVideo: !!fullVideo,
  //         closeButton: !!closeButton,
  //         loader: !!loader,
  //       });
  //       return; // Skip this iteration
  //     }

  //     // Get video URL and determine if it's an iframe (Vimeo/YouTube)
  //     const videoUrl = preview.dataset.videoUrl;
  //     const isIframe =
  //       videoUrl.includes("vimeo.com") || videoUrl.includes("youtube.com");

  //     // Set preview and full video sources
  //     if (isIframe) {
  //       previewVideo.src = videoUrl;
  //       fullVideo.src = videoUrl.replace("autoplay=1", "");
  //     } else {
  //       previewVideo.src = videoUrl;
  //       fullVideo.src = videoUrl;
  //     }

  //     // Function to hide loader
  //     const hideLoader = () => {
  //       loader.style.display = "none";
  //       preview.classList.add("dialog-video__loading");
  //     };

  //     // Handle preview video/iframe playback
  //     if (isIframe && videoUrl.includes("vimeo.com")) {
  //       const player = new Vimeo.Player(previewVideo);
  //       player.on("loaded", () => {
  //         hideLoader(); // Hide loader when Vimeo video is loaded
  //         player.setCurrentTime(startTime).then(() => {
  //           player.play().catch((error) => {
  //             console.log(
  //               `Autoplay prevented for Vimeo video ${index + 1}:`,
  //               error
  //             );
  //             document.addEventListener(
  //               "click",
  //               () => {
  //                 player.play();
  //               },
  //               { once: true }
  //             );
  //           });
  //         });
  //       });
  //       player.on("timeupdate", (data) => {
  //         if (data.seconds >= endTime) {
  //           player.setCurrentTime(startTime);
  //         }
  //       });
  //       // Hide loader on error to prevent infinite loading
  //       player.on("error", () => {
  //         console.error(`Error loading Vimeo video ${index + 1}`);
  //         hideLoader();
  //       });
  //     } else {
  //       previewVideo.addEventListener("loadedmetadata", () => {
  //         hideLoader(); // Hide loader when HTML5 video metadata is loaded
  //         previewVideo.currentTime = startTime;
  //         previewVideo.play().catch((error) => {
  //           console.log(`Autoplay prevented for video ${index + 1}:`, error);
  //           document.addEventListener(
  //             "click",
  //             () => {
  //               previewVideo.play();
  //             },
  //             { once: true }
  //           );
  //         });
  //       });
  //       previewVideo.addEventListener("timeupdate", () => {
  //         if (previewVideo.currentTime >= endTime) {
  //           previewVideo.currentTime = startTime;
  //         }
  //       });
  //       // Hide loader on error to prevent infinite loading
  //       previewVideo.addEventListener("error", () => {
  //         console.error(`Error loading video ${index + 1}`);
  //         hideLoader();
  //       });
  //     }

  //     // Open popup and play full video
  //     playButton.addEventListener("click", () => {
  //       if (isIframe && videoUrl.includes("vimeo.com")) {
  //         const fullPlayer = new Vimeo.Player(fullVideo);
  //         if (previewVideo.tagName === "IFRAME") {
  //           const previewPlayer = new Vimeo.Player(previewVideo);
  //           previewPlayer.pause();
  //         } else {
  //           previewVideo.pause();
  //         }
  //         document.body.classList.add("dialog-box__open");
  //         gsap.to(videoPopup, {
  //           opacity: 1,
  //           duration: 0.2,
  //           ease: "power2.out",
  //           onStart: () => {
  //             videoPopup.style.display = "flex";
  //             videoPopup.style.pointerEvents = "auto";
  //           },
  //         });
  //         gsap.to(popupContent, {
  //           opacity: 1,
  //           // scale: 1,
  //           duration: 0.5,
  //           ease: "power2.out",
  //           delay: 0.2,
  //           onComplete: () => {
  //             fullPlayer.play();
  //           },
  //         });
  //       } else {
  //         previewVideo.pause();
  //         document.body.classList.add("dialog-box__open");
  //         gsap.to(videoPopup, {
  //           opacity: 1,
  //           duration: 0.2,
  //           ease: "power2.out",
  //           onStart: () => {
  //             videoPopup.style.display = "flex";
  //             videoPopup.style.pointerEvents = "auto";
  //           },
  //         });
  //         gsap.to(popupContent, {
  //           opacity: 1,
  //           // scale: 1,
  //           duration: 0.5,
  //           ease: "power2.out",
  //           delay: 0.2,
  //           onComplete: () => {
  //             fullVideo.play();
  //           },
  //         });
  //       }
  //     });

  //     // Close popup and handle video/iframe behavior
  //     closeButton.addEventListener("click", () => {
  //       gsap.to(popupContent, {
  //         opacity: 0,
  //         // scale: 0.8,
  //         duration: 0.5,
  //         ease: "power2.in",
  //         onStart: () => {
  //           if (isIframe && videoUrl.includes("vimeo.com")) {
  //             const fullPlayer = new Vimeo.Player(fullVideo);
  //             fullPlayer.pause();
  //             if (fullVideo.dataset.videoBehavior === "restart") {
  //               fullPlayer.setCurrentTime(0);
  //             }
  //             if (previewVideo.tagName === "IFRAME") {
  //               const previewPlayer = new Vimeo.Player(previewVideo);
  //               previewPlayer.play();
  //             } else {
  //               previewVideo.play();
  //             }
  //           } else {
  //             fullVideo.pause();
  //             if (fullVideo.dataset.videoBehavior === "restart") {
  //               fullVideo.currentTime = 0;
  //             }
  //             previewVideo.play();
  //           }
  //         },
  //       });
  //       gsap.to(videoPopup, {
  //         opacity: 0,
  //         duration: 0.2,
  //         ease: "power2.in",
  //         delay: 0.5,
  //         onComplete: () => {
  //           videoPopup.style.display = "none";
  //           videoPopup.style.pointerEvents = "none";
  //           document.body.classList.remove("dialog-box__open");
  //         },
  //       });
  //     });

  //     // Close popup on ESC key
  //     document.addEventListener("keydown", (e) => {
  //       if (e.key === "Escape" && videoPopup.style.display !== "none") {
  //         closeButton.click();
  //       }
  //     });
  //   });
  // }

  // handleVideoPreview();

    function handleVideoPreview() {
    const videoPreviews = document.querySelectorAll(".video-preview");
    const startTime = 0;
    const endTime = 5;

    // Store all video instances globally to manage playback
    const videoInstances = [];

    videoPreviews.forEach((preview, index) => {
      // Select all required elements
      const previewVideo = preview.querySelector(".preview-video");
      const playButton = preview.querySelector(".play-button");
      const loader = document.getElementById(`loader-${index + 1}`);

      // Validate required elements
      if (!previewVideo || !playButton || !loader) {
        console.error(
          `Missing required elements for video block ${index + 1}`,
          {
            previewVideo: !!previewVideo,
            playButton: !!playButton,
            loader: !!loader,
          }
        );
        return;
      }

      // Get popup elements
      const videoPopup = document.getElementById(`dialog-video__${index + 1}`);
      const popupContent = document.getElementById(
        `dialog-content__${index + 1}`
      );
      const fullVideo = document.getElementById(
        `dialog-full__video-${index + 1}`
      );
      const closeButton = document.getElementById(
        `dialog-close__btn-${index + 1}`
      );

      // Determine mode with proper attribute checking
      const hasPopupElements =
        videoPopup && popupContent && fullVideo && closeButton;
      const playInPlaceAttr = preview.dataset.playInPlace;

      // Logic:
      // - If data-play-in-place="true" -> play in place
      // - If data-play-in-place="false" -> force popup mode (even without popup elements)
      // - If no attribute and no popup elements -> play in place (fallback)
      // - If no attribute and has popup elements -> popup mode (default)
      let playInPlace;
      if (playInPlaceAttr === "true") {
        playInPlace = true;
      } else if (playInPlaceAttr === "false") {
        playInPlace = false;
        // Validate popup elements are available when forced to popup mode
        if (!hasPopupElements) {
          console.error(
            `Video block ${
              index + 1
            } has data-play-in-place="false" but missing popup elements`
          );
          return;
        }
      } else {
        // No attribute: use popup if elements exist, otherwise play in place
        playInPlace = !hasPopupElements;
      }

      // Get video URL and determine if it's an iframe (Vimeo/YouTube)
      const videoUrl = preview.dataset.videoUrl;
      const isIframe =
        videoUrl.includes("vimeo.com") || videoUrl.includes("youtube.com");

      // Set preview and full video sources
      if (isIframe) {
        previewVideo.src = videoUrl;
        if (!playInPlace && fullVideo) {
          fullVideo.src = videoUrl.replace("autoplay=1", "");
        }
      } else {
        previewVideo.src = videoUrl;
        if (!playInPlace && fullVideo) {
          fullVideo.src = videoUrl;
        }
      }

      // Function to hide loader
      const hideLoader = () => {
        loader.style.display = "none";
        preview.classList.add("dialog-video__loading");
      };

      // Track if we're in preview mode or full playback mode
      let isPreviewMode = true;
      let vimeoPlayer = null; // Store Vimeo player instance
      let isPlayingFull = false; // Track if this video is playing full

      // Store video instance info
      const videoInstance = {
        index: index + 1,
        previewVideo,
        playButton,
        isIframe,
        vimeoPlayer: null,
        playInPlace,
        stopFullPlayback: () => {
          if (isPlayingFull) {
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.pause();
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
            } else {
              previewVideo.pause();
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true;
            }
            playButton.style.opacity = "1";
            playButton.style.pointerEvents = "auto";
            isPreviewMode = true;
            isPlayingFull = false;

            // Resume preview playback
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.play();
            } else {
              previewVideo.play();
            }
          }
        },
      };
      videoInstances.push(videoInstance);

      // Handle preview video/iframe playback
      if (isIframe && videoUrl.includes("vimeo.com")) {
        vimeoPlayer = new Vimeo.Player(previewVideo);
        videoInstance.vimeoPlayer = vimeoPlayer;

        vimeoPlayer.on("loaded", () => {
          hideLoader();
          vimeoPlayer.setCurrentTime(startTime).then(() => {
            vimeoPlayer.play().catch((error) => {
              console.log(
                `Autoplay prevented for Vimeo video ${index + 1}:`,
                error
              );
              document.addEventListener(
                "click",
                () => {
                  vimeoPlayer.play();
                },
                { once: true }
              );
            });
          });
        });
        vimeoPlayer.on("timeupdate", (data) => {
          // Only loop preview if in preview mode
          if (isPreviewMode && data.seconds >= endTime) {
            vimeoPlayer.setCurrentTime(startTime);
          }
        });
        vimeoPlayer.on("error", () => {
          console.error(`Error loading Vimeo video ${index + 1}`);
          hideLoader();
        });
      } else {
        previewVideo.addEventListener("loadedmetadata", () => {
          hideLoader();
          previewVideo.currentTime = startTime;
          previewVideo.play().catch((error) => {
            console.log(`Autoplay prevented for video ${index + 1}:`, error);
            document.addEventListener(
              "click",
              () => {
                previewVideo.play();
              },
              { once: true }
            );
          });
        });
        previewVideo.addEventListener("timeupdate", () => {
          // Only loop preview if in preview mode
          if (isPreviewMode && previewVideo.currentTime >= endTime) {
            previewVideo.currentTime = startTime;
          }
        });
        previewVideo.addEventListener("error", () => {
          console.error(`Error loading video ${index + 1}`);
          hideLoader();
        });
      }

      // Add click handler to video for play-in-place mode to stop playback
      if (playInPlace) {
        const handleVideoClick = (e) => {
          // Only handle click if video is playing in full mode and not clicking the play button
          if (isPlayingFull && !playButton.contains(e.target)) {
            e.stopPropagation();
            // Stop full playback and return to preview
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.pause();
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
              vimeoPlayer.play();
            } else {
              previewVideo.pause();
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true;
              previewVideo.play();
            }
            playButton.style.opacity = "1";
            playButton.style.pointerEvents = "auto";
            isPreviewMode = true;
            isPlayingFull = false;
          }
        };

        preview.addEventListener("click", handleVideoClick);
      }

      // Handle play button click
      playButton.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent video click handler from firing

        if (playInPlace) {
          // Stop all other videos that are playing in full
          videoInstances.forEach((instance) => {
            if (instance.index !== index + 1 && instance.playInPlace) {
              instance.stopFullPlayback();
            }
          });

          // Switch to full playback mode
          isPreviewMode = false;
          isPlayingFull = true;

          // Hide play button immediately
          playButton.style.opacity = "0";
          playButton.style.pointerEvents = "none";

          // Play in place: play full video in the same container
          if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
            vimeoPlayer
              .setCurrentTime(0)
              .then(() => {
                vimeoPlayer.setLoop(false);
                vimeoPlayer.play();
              })
              .catch((error) => {
                console.error(
                  `Error playing full Vimeo video ${index + 1}:`,
                  error
                );
                // Show play button again if there's an error
                playButton.style.opacity = "1";
                playButton.style.pointerEvents = "auto";
                isPreviewMode = true;
                isPlayingFull = false;
              });

            // Show play button again when video ends
            vimeoPlayer.on("ended", () => {
              playButton.style.opacity = "1";
              playButton.style.pointerEvents = "auto";
              isPreviewMode = true;
              isPlayingFull = false;
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
              vimeoPlayer.play();
            });
          } else {
            // For HTML5 video
            previewVideo.currentTime = 0;
            previewVideo.loop = false;
            previewVideo.muted = false; // Unmute for full playback

            // Play the video
            const playPromise = previewVideo.play();

            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error(`Error playing full video ${index + 1}:`, error);
                // Show play button again if there's an error
                playButton.style.opacity = "1";
                playButton.style.pointerEvents = "auto";
                isPreviewMode = true;
                isPlayingFull = false;
                previewVideo.muted = true;
              });
            }

            // Show play button again when video ends
            const handleVideoEnd = () => {
              playButton.style.opacity = "1";
              playButton.style.pointerEvents = "auto";
              isPreviewMode = true;
              isPlayingFull = false;
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true; // Mute again for preview
              previewVideo.play();
              previewVideo.removeEventListener("ended", handleVideoEnd);
            };
            previewVideo.addEventListener("ended", handleVideoEnd);
          }
        } else {
          // Stop all other videos that are playing in full (play-in-place ones)
          videoInstances.forEach((instance) => {
            if (instance.playInPlace) {
              instance.stopFullPlayback();
            }
          });

          // Original popup behavior
          if (isIframe && videoUrl.includes("vimeo.com")) {
            const fullPlayer = new Vimeo.Player(fullVideo);
            if (previewVideo.tagName === "IFRAME") {
              if (vimeoPlayer) {
                vimeoPlayer.pause();
              }
            } else {
              previewVideo.pause();
            }
            document.body.classList.add("dialog-box__open");
            gsap.to(videoPopup, {
              opacity: 1,
              duration: 0.2,
              ease: "power2.out",
              onStart: () => {
                videoPopup.style.display = "flex";
                videoPopup.style.pointerEvents = "auto";
              },
            });
            gsap.to(popupContent, {
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              delay: 0.2,
              onComplete: () => {
                fullPlayer.play();
              },
            });
          } else {
            previewVideo.pause();
            document.body.classList.add("dialog-box__open");
            gsap.to(videoPopup, {
              opacity: 1,
              duration: 0.2,
              ease: "power2.out",
              onStart: () => {
                videoPopup.style.display = "flex";
                videoPopup.style.pointerEvents = "auto";
              },
            });
            gsap.to(popupContent, {
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              delay: 0.2,
              onComplete: () => {
                fullVideo.play();
              },
            });
          }
        }
      });

      // Close popup functionality (only for popup mode)
      if (!playInPlace && closeButton) {
        closeButton.addEventListener("click", () => {
          gsap.to(popupContent, {
            opacity: 0,
            duration: 0.5,
            ease: "power2.in",
            onStart: () => {
              if (isIframe && videoUrl.includes("vimeo.com")) {
                const fullPlayer = new Vimeo.Player(fullVideo);
                fullPlayer.pause();
                if (fullVideo.dataset.videoBehavior === "restart") {
                  fullPlayer.setCurrentTime(0);
                }
                if (previewVideo.tagName === "IFRAME") {
                  if (vimeoPlayer) {
                    vimeoPlayer.play();
                  }
                } else {
                  previewVideo.play();
                }
              } else {
                fullVideo.pause();
                if (fullVideo.dataset.videoBehavior === "restart") {
                  fullVideo.currentTime = 0;
                }
                previewVideo.play();
              }
            },
          });
          gsap.to(videoPopup, {
            opacity: 0,
            duration: 0.2,
            ease: "power2.in",
            delay: 0.5,
            onComplete: () => {
              videoPopup.style.display = "none";
              videoPopup.style.pointerEvents = "none";
              document.body.classList.remove("dialog-box__open");
            },
          });
        });

        // Close popup on ESC key
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && videoPopup.style.display !== "none") {
            closeButton.click();
          }
        });
      }
    });
  }

  handleVideoPreview();


    //----------------------------
  // Function to handle opening and closing modals
  //---------------

  function openingPopUp() {
    var learnMoreLinks = document.querySelectorAll(".learn-more-link, .has__popup");
    var closeBtns = document.querySelectorAll(".close, [data-close-popup]");

    learnMoreLinks.forEach(function (learnMoreLink) {
      learnMoreLink.onclick = function (event) {
        event.preventDefault();

        var modalId = learnMoreLink.getAttribute("data-target");
        var modal = document.getElementById(modalId);

        if (modal) {
          modal.style.display = "block";
        }
      };
    });

    closeBtns.forEach(function (closeBtn) {
      closeBtn.onclick = function () {
        var modal = closeBtn.closest(".modal");
        if (modal) {
          modal.style.display = "none";
        }
      };
    });

    window.onclick = function (event) {
      document.querySelectorAll(".modal").forEach(function (modal) {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    };
  }
  openingPopUp();


});